/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConsentFormsDto
 */
export interface ConsentFormsDto {
    /**
     * Array of signed URLs to consent documents for the practice
     * @type {Array<string>}
     * @memberof ConsentFormsDto
     */
    urls: Array<string>;
}

/**
 * Check if a given object implements the ConsentFormsDto interface.
 */
export function instanceOfConsentFormsDto(value: object): value is ConsentFormsDto {
    if (!('urls' in value) || value['urls'] === undefined) return false;
    return true;
}

export function ConsentFormsDtoFromJSON(json: any): ConsentFormsDto {
    return ConsentFormsDtoFromJSONTyped(json, false);
}

export function ConsentFormsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsentFormsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'urls': json['urls'],
    };
}

export function ConsentFormsDtoToJSON(json: any): ConsentFormsDto {
    return ConsentFormsDtoToJSONTyped(json, false);
}

export function ConsentFormsDtoToJSONTyped(value?: ConsentFormsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'urls': value['urls'],
    };
}

